import React from "react";
import { useNavigate } from "react-router-dom";

const Step_one = ({
  filters,
  prevStep,
  nextStep,
  allCategories,
  onFilterChange,
  setCategory
}) => {
  const navigate = useNavigate();
 
  return (
    <>
      <section className="quizformsection">
        <div className="navigationdiv">
          <div className="row">
            <div className="col-12 text-center">
              <p className="formstepps">1/05</p>
            </div>
            <div className="col-12 text-center">
              <div className="formtitlediv">
                <h2 className="formtitle">What are you looking for?</h2>
                <button
                  className="backbtn"
                  type="button"
                  onClick={() => navigate("/")}
                >
                  <img
                    className="backicon"
                    src={
                      process.env.PUBLIC_URL +
                      "/assets/images/quick-quiz/backbtn.png"
                    }
                  />
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="productsdiv">
          <div className="row justify-content-center">
            {allCategories?.map((data) => (
              <div className="col-lg-4 col-sm-6  mb-3">
                {/* <div className='productcard' onClick={() => { onFilterChange("category", { id: data?.id, name: data.name }); nextStep() }}> */}
                <div
                  className="productcard"
                  onClick={() => {
                    onFilterChange("category", {
                      id: data?.id,
                      name: data.name,
                    });
                    setCategory(data);

                    if (data?.id === 2 || data?.id === 5) {
                      nextStep();
                    } else {
                      navigate("/all-products");
                    }
                    
                  }}
                >
                  <img
                    className="bgimg"
                    src={
                      process.env.PUBLIC_URL +
                      "/assets/images/quick-quiz/frame1.png"
                    }
                  />

                  <div className="oevrlaycont">
                    <div className="prodimgdiv">
                      <img
                        className="prod_img"
                        src={process.env.REACT_APP_IMAGE_URL + data?.image}
                      />
                    </div>

                    <p className="prodname">{data?.name}</p>
                  </div>
                </div>
              </div>
            ))}
            {/*<div className='col-lg-4 col-sm-6  mb-3'>
                           <div className='productcard'>
                                <img className='bgimg' src={process.env.PUBLIC_URL + '/assets/images/quick-quiz/frame1.png'} />

                                <div className='oevrlaycont'>
                                    <div className='prodimgdiv'>
                                        <img className='prod_img' src={process.env.PUBLIC_URL + '/assets/images/quick-quiz/eyeglass.png'} />
                                    </div>

                                    <p className='prodname'>Eyeglasses</p>
                                </div>
                            </div> 
                            <div className='productcard'>
                                <img className='bgimg' src={process.env.PUBLIC_URL + '/assets/images/quick-quiz/frame1.png'} />

                                <div className='oevrlaycont'>
                                    <div className='prodimgdiv'>
                                        <img className='prod_img' src={process.env.PUBLIC_URL + '/assets/images/quick-quiz/sunglass.png'} />
                                    </div>
                                    <p className='prodname'>Sunglasses</p>
                                </div>
                            </div>
                        </div>
                        */}
          </div>
        </div>

        <div className="nextbuttondiv">
          <button className="nextbtn" onClick={nextStep}>
            "Can’t say for now, let's skip."
          </button>
        </div>
      </section>
    </>
  );
};

export default Step_one;
